import { CompetitionsModule } from 'src/app/modules/competitions/competitions.module';
import { ChatModule } from 'src/app/modules/chat/chat.module';
import { ApplicationModule } from 'src/app/modules/application/application.module';
import { MetaModule } from 'src/app/modules/meta/meta.module';

export { CompetitionsModule, ChatModule, ApplicationModule, MetaModule };

export default [CompetitionsModule, ChatModule, ApplicationModule, MetaModule];
